export default {
  header: {
    title: "DRINK [bwaʁ] n.m. : Slang, neologism, common name inspired by the English word drinks. In our popular jargon, we use it to designate thirst-quenching drinks, in particular the wines of our agency."
  },
  left: {
    title: 'COMPANY',
    p1: 'Boires is a team of wine and gastronomy enthusiasts. We are constantly searching, exploring rural regions to discover wines and other products from environments where nature thrives.',
    p2: 'The agency was founded in 2013 with the goal of representing artisanal producers and introducing them to wine enthusiasts, whether they are individuals or professionals. Our work leads us to develop the markets in Ontario and Quebec.'
  },
  right: {
    title: 'MISSION',
    p1: 'We strive to showcase the results of talented artisans’ work, coming from renowned or emerging regions.',
    p2: 'Our selection of products reflects the vision and values of our company: promoting authenticity and respect for the environment, while staying focused on an ever-evolving alcohol market.',
    p3: 'We prioritize producers who are committed to offering a unique product that stands out from generic best-sellers.'
  },
  contactUs: {
    title: "CONTACT US",
    first: "First name",
    last: "Last name",
    email: "Email",
    subject: "Subject",
  },
  address1: {
    title: "MONTREAL",
    desc: '6422 boul. Saint-Laurent, local 102. <br> Montreal, QC - H2S 3C4',
  },
  address2: {
    title: "QUEBEC",
    desc: '281 rue de la Couronne <br> Quebec, QC - G1K 6E2',
  },
  address3: {
    title: "TORONTO",
    desc: '1583 Dupont St, Toronto <br> Toronto, ON, M6P 3S5',
  },
  form: {
    checkbox: 'I am not a robot',
    button: 'Send'
  }
}
